import { bricklinkUploadDialogStateSchema } from '@state/_shared/bricklinkUploadDialogStateSchema';

// The My Sets page keeps its own state in a useReducer. This schema exists only
// so the shared <BricklinkUploadDialog /> can read its state by pageName through
// AppStateProvider, which throws "Schema not found for page" without it.
export const userSetsPageStateSchema = {
    bricklinkUploadDialog: bricklinkUploadDialogStateSchema
};

export default userSetsPageStateSchema;
